import ReactNative from '../base_components';
import React from 'react';

const { StyleSheet, View, Image, TouchableHighlight } = ReactNative;

const styles = StyleSheet.create({
  imageButton: {
    flexDirection: 'row',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    flex: 1,
    alignSelf: 'stretch',
  },
});

type Props = {
  style: any;
  source: string;
  underlayColor?: string;
};

export default class ImageButton extends React.PureComponent<Props> {
  render() {
    const { style, source, underlayColor, onPress } = this.props;

    return (
      <View style={[styles.imageButton, style]}>
        <TouchableHighlight
          style={styles.highlight}
          underlayColor={underlayColor || 'rgba(255,255,255,0.2)'}
          onPress={onPress}
        >
          <Image style={styles.icon} resizeMode='cover' source={source} />
        </TouchableHighlight>
      </View>
    );
  }
}
